
export type GetTweetById200ReferencedTweetType = typeof GetTweetById200ReferencedTweetType[keyof typeof GetTweetById200ReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200ReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
